"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.hasFirstAndSecondListingProperty = exports.hasSecondListing = exports.hasListingArray = void 0;
exports.hasListingArray = function (claim) {
    return claim != null && Array.isArray(claim.listing) && claim.listing.length > 0;
};
exports.hasSecondListing = function (claim) {
    return claim != null && Array.isArray(claim.listing) && claim.listing.length > 1;
};
exports.hasFirstAndSecondListingProperty = function (claim, property) {
    return claim != null &&
        Array.isArray(claim.listing) &&
        claim.listing.length > 1 &&
        claim.listing[0][property] &&
        claim.listing[1][property];
};
